webpackJsonp([204940132286570],{

/***/ 132:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(39);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _doktrak_logo = __webpack_require__(132);
	
	var _doktrak_logo2 = _interopRequireDefault(_doktrak_logo);
	
	var _favicon = __webpack_require__(54);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	var _favicon3 = __webpack_require__(55);
	
	var _favicon4 = _interopRequireDefault(_favicon3);
	
	var _favicon5 = __webpack_require__(56);
	
	var _favicon6 = _interopRequireDefault(_favicon5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mailToLink = 'mailto:sales@rekon.com?Subject=Rekon%20Website%3A%20Requesting%20Software%20Demonstration';
	// import Link from 'gatsby-link'
	
	
	var DokTrakPage = function DokTrakPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'DokTrak',
	      meta: [{ name: 'description', content: 'DokTrak: Servicers\' most versatile and comprehensive document management and tracking technology.' }],
	      link: [{ rel: "icon", type: "image/png", sizes: "16x16", href: '' + _favicon2.default }, { rel: "icon", type: "image/png", sizes: "32x32", href: '' + _favicon4.default }, { rel: "shortcut icon", type: "image/png", href: '' + _favicon6.default }]
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'hero hero-product hero-doktrak is-medium' },
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container has-text-centered' },
	          _react2.default.createElement('img', { src: _doktrak_logo2.default, alt: 'DokTrak logo', className: 'product-logo' }),
	          _react2.default.createElement(
	            'h1',
	            { className: 'title' },
	            'The Ultimate Document Management Solution'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'DokTrak empowers servicers of all sizes to regain control of their loan documents and files with a single technology solution.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'section product-features' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'title has-text-centered' },
	          'With DokTrak, knowledge and control are yours, all the time:'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'features-list-container columns is-mobile is-multiline' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-full-mobile is-4-desktop' },
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Track any file or document, ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'anywhere'
	                ),
	                ', at ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'any time'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Quickly'
	                ),
	                ' generate document and file barcode labels'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Effectively'
	                ),
	                ' identify and resolve all exceptions'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-full-mobile is-5-desktop' },
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Efficiently process'
	                ),
	                ' certification of pools and loan files'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Improve'
	                ),
	                ' the foreclosure paperwork process'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Lower ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'retrieval cost'
	                ),
	                ' and ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'turnaround time'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Automate'
	                ),
	                ' custodian document reconciliations'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-full-mobile is-3-desktop' },
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Manage'
	                ),
	                ' files and documents requests '
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Store and update'
	                ),
	                ' loan data'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Create ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'customized reports'
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'section product-promo' },
	      _react2.default.createElement(
	        'div',
	        { className: 'has-text-centered' },
	        _react2.default.createElement(
	          'span',
	          { className: 'title fg-grey block' },
	          'You need to get it right.'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'title fg-success block' },
	          'DokTrak makes it happen.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'core-features' },
	      _react2.default.createElement(
	        'div',
	        { className: 'section container has-text-centered' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'title' },
	          'Regain Control of Your Documents'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'DokTrak enables servicers to master document administration throughout the entire servicing life cycle.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'columns core-features-columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column' },
	            _react2.default.createElement(
	              'h3',
	              { className: 'title' },
	              _react2.default.createElement('i', { className: 'has-icon icon-folder' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'is-centered' },
	                'Total File ',
	                _react2.default.createElement('br', null),
	                ' Access'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'DokTrak tracks the exact location of every document and every file, whether it\u2019s with a custodian, at an off-site location, or in your own file room\u2014right down to the row, bin, shelf or even box\u2014all with just a few clicks.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column' },
	            _react2.default.createElement(
	              'h3',
	              { className: 'title' },
	              _react2.default.createElement('i', { className: 'has-icon icon-deficiencies' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'is-centered' },
	                'Eliminate Deficiencies'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'DokTrak quickly identifies post-closing deficiencies, manages exception resolution, and ensures compliance with ease.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column' },
	            _react2.default.createElement(
	              'h3',
	              { className: 'title' },
	              _react2.default.createElement('i', { className: 'has-icon icon-streamline' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'is-centered' },
	                'Streamline Document Requests'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Order, track, and retrieve all document requests with a few mouse clicks on a single software platform.'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement('section', { className: 'hero has-border' }),
	    _react2.default.createElement(
	      'section',
	      { className: 'section container-cta has-text-centered' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'title fg-success' },
	        'With DokTrak, document control is finally possible.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'See why DokTrak is the servicing industry\u2019s most comprehensive document management and tracking solution.'
	      ),
	      _react2.default.createElement(
	        'button',
	        { onClick: function onClick() {
	            return window.location.href = mailToLink;
	          }, className: 'button is-primary is-large', 'aria-label': 'Request a Demo of our Software' },
	        'Schedule a demo today'
	      )
	    )
	  );
	};
	
	exports.default = DokTrakPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-doktrak-js-a4ce84b9e97de91b87dd.js